import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useSessionStorage from "./useSessionStorage";

import "./FormStyles.css";
import "./Table.css";
import useAxios from "./useAxios";

const Table = () => {
  const { id } = useParams();
  const [table, setTable] = useState(null);
  const [streamTypes, setStreamTypes] = useState([]);
  const [gameTypes, setGameTypes] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [axios] = useAxios(true);
  const navigate = useNavigate();
  const [tenant] = useSessionStorage("tenant");

  useEffect(() => {
    axios.get("table/" + id, setTable);
    axios.get("streamtypes", setStreamTypes);
    axios.get("gametypes", setGameTypes);
    if (tenant.super) {
      axios.get("tenants", setTenants);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTable((prevTable) => ({
      ...prevTable,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleStreamTypeChange = (e) => {
    const { name, value, type, checked } = e.target;
    let streamType = streamTypes.find((streamType) => streamType.id === value);
    setTable((prevTable) => ({
      ...prevTable,
      streamType: streamType,
    }));
  };

  const handleGameTypeChange = (e) => {
    const { value } = e.target;
    let gameType = gameTypes.find((gt) => gt.id === value);
    setTable((prevTable) => ({
      ...prevTable,
      gameType: gameType,
    }));
  };

  const handleTenantChange = (e) => {
    const { value } = e.target;
    let selectedTenant = tenants.find((t) => t.id === value);
    setTable((prevTable) => ({
      ...prevTable,
      tenant: selectedTenant,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setTable((prevTable) => ({ ...prevTable, [name]: checked }));
  };

  const onSave = () => {
    axios.post("table/" + id, table, onCancel);
  };

  const onCancel = () => {
    navigate("/configuration/tables");
  };

  if (table === null) {
    return <h1>Loading</h1>;
  }

  return (
    <div className="edit-table-form">
      <h2>Edit Table</h2>
      <form className="table-form-fields">
        {tenant.super && (
          <div className="form-group">
            <label htmlFor="tenant">Tenant:</label>
            <select
              name="tenant"
              id="tenant"
              value={table.tenant?.id}
              onChange={handleTenantChange}
              required
              className="form-control"
            >
              <option value="">Select a tenant</option>
              {tenants.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            name="name"
            id="name"
            value={table.name}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="shortId">Short Code:</label>
          <input
            type="text"
            name="shortId"
            id="shortId"
            value={table.shortId}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="streamType">Stream:</label>
          <select
            name="streamType"
            id="streamType"
            value={table.streamType?.id}
            onChange={handleStreamTypeChange}
            className="form-control"
          >
            <option value="">None</option>
            {streamTypes
              .filter((st) => {
                if (tenant.super) {
                  return table.tenant && st.tenant?.id === table.tenant.id;
                } else {
                  return st.tenant?.id === tenant.id;
                }
              })
              .map((streamType) => (
                <option key={streamType.id} value={streamType.id}>
                  {streamType.name}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="gameType">Game Type:</label>
          <select
            name="gameType"
            id="gameType"
            value={table.gameType?.id || ""}
            onChange={handleGameTypeChange}
            className="form-control"
          >
            <option value="">Select a game type</option>
            {gameTypes.map((gameType) => (
              <option key={gameType.id} value={gameType.id}>
                {gameType.description}
              </option>
            ))}
          </select>
        </div>
        <div className="form-buttons">
          <button type="button" onClick={onSave} className="submit-button">
            Save
          </button>
          <button type="button" onClick={onCancel} className="cancel-button">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Table;
